module.exports = __webpack_public_path__ + "static/media/buitenland.23b6be95.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/buitenland.svg
// module id = 352
// module chunks = 0